import React, { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { Container } from '../../../components/common/Container'
import { SideBar } from '../../../components/common/SideBar'

interface SocietyLayoutProps {
  sidebar: ReactNode
  noContainer?: boolean
}

export const SocietyLayout = ({
  sidebar,
  noContainer,
}: SocietyLayoutProps): React.ReactNode => {
  return (
    <>
      <SideBar
        className="gap-gutter flex"
        padding={false}
        headerClassName="px-6 pt-6"
      >
        {sidebar}
      </SideBar>
      {noContainer ? (
        <Outlet />
      ) : (
        <div className="relative w-full min-w-0 overflow-y-auto">
          <Container>
            <Outlet />
          </Container>
        </div>
      )}
    </>
  )
}

SocietyLayout.displayName = 'SocietyLayout'
